import { Service, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs';

import { ContextStateService } from '@core/services/context-state.service';

@Service()
export class AdminGuard {
    private readonly contextService = inject(ContextStateService);
    private isLoggedUserSuperAdmin = this.contextService.isLoggedUserSuperAdmin;
    private isCurrentContextLoaded$ = toObservable(this.contextService.isCurrentContextLoaded);
    public canActivate() {
        return this.isCurrentContextLoaded$.pipe(
            filter(isLoaded => isLoaded),
            take(1),
            map(() => this.isLoggedUserSuperAdmin())
        );
    }
}
